<template>
  <Layout title="" description="">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="d-flex align-items-center gap-3">
        <router-link to="/crm" class="text-muted text-decoration-none small">&larr; Back to Clients</router-link>
        <div style="width: 50px; height: 50px; background: linear-gradient(135deg, #e9aaff, #c77dff); border-radius: 50%;">
          <div class="d-flex align-items-center justify-content-center h-100 fw-bold text-white">
            {{ customer.initials }}
          </div>
        </div>
        <div>
          <h4 class="mb-0 fw-bold">{{ customer.CompanyName }}</h4>
          <div class="text-muted small">{{ customer.industry }}</div>
        </div>
      </div>

      <!-- <div class="d-flex gap-2">
        <button class="btn btn-sm text-white" style="background: linear-gradient(to right, #d946ef, #8b5cf6);">
          <i class="bi bi-calendar-event me-1"></i>Schedule Meeting
        </button>
      </div> -->
    </div>
    <div class="overflow-x-auto">
  <div class="d-flex gap-2 mb-2 flex-nowrap" style="min-width: max-content;">
    <button
      class="btn px-3 py-1 rounded-pill fw-semibold"
      :class="tab === 'Overview' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
      @click="tab = 'Overview'"
    >
      Overview
    </button>

    <button
      class="btn px-3 py-1 rounded-pill fw-semibold"
      :class="tab === 'Notes' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
      @click="tab = 'Notes'"
    >
      Notes
    </button>

    <button
      class="btn px-3 py-1 rounded-pill fw-semibold"
      :class="tab === 'marketTrend' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
      @click="tab = 'marketTrend'"
    >
      Market Trend
    </button>

    <button
      class="btn px-3 py-1 rounded-pill fw-semibold"
      :class="tab === 'Ideas' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
      @click="tab = 'Ideas'"
    >
      Ideas
    </button>

    <button
      class="btn px-3 py-1 rounded-pill fw-semibold"
      :class="tab === 'Sentiment' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
      @click="tab = 'Sentiment'"
    >
      Sentiment
    </button>
  </div>
</div>

      <div v-show="tab === 'Overview'">
          <div class="row g-4">
            <!-- Company Info -->
            <div class="col-md-12">
              <div class="border rounded-4 p-4 h-100" style="background-color:white">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex align-items-center">
                    <Building2 class="me-2" :size="18" />
                    <h6 class="fw-bold mb-0">Company Information</h6>
                  </div>
                  <button
                    class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                    :disabled="isSaving"
                    @click="handleButtonClick"
                  >
                    <template v-if="isSaving">
                      <span class="spinner-border spinner-border-sm" role="status" />
                      Saving...
                    </template>

                    <template v-else-if="editMode">
                      Save
                    </template>

                    <template v-else>
                       Edit
                    </template>
                  </button>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-3">
                    <div class="mb-1 fw-bold">Contact Person</div>
                    <div class="d-flex align-items-center text-dark">
                      <UserRound class="me-2 text-muted" :size="18" />
                      <template v-if="editMode">
                        <input v-model="customer.contactPerson" type="text" class="form-control form-control-sm" :style="{
                                background: 'transparent',
                                border: 'none',
                                borderBottom: '1px solid #ccc',
                                borderRadius: '0',
                                padding: '2px 0',
                                fontSize: '0.9rem',
                                width: '100%',
                                outline: 'none'
                              }" />
                      </template>
                      <template v-else>
                        {{ customer.contactPerson }}
                      </template>
                    </div>
                  </div>
                  <!-- Role -->
                  <div class="col-md-6 mb-3">
                    <div class="mb-1 fw-bold">Role/Position</div>
                    <div class="d-flex align-items-center text-dark">
                      <Network class="me-2 text-muted" :size="18" />
                      <template v-if="editMode">
                        <select v-model="customer.role" class="form-control form-control-sm" 
                          :style="{
                            background: 'transparent',
                            border: 'none',
                            borderBottom: '1px solid #ccc',
                            borderRadius: '0',
                            padding: '2px 0',
                            fontSize: '0.9rem',
                            width: '100%',
                            outline: 'none'
                          }">
                          <option value="Owner/C-Suite">Owner/C-Suite</option>
                          <option value="Manager/Team Lead">Manager/Team Lead</option>
                          <option value="Staff/Exec">Staff/Exec</option>
                          <option value="Others">Others</option>
                        </select>
                      </template>
                      <template v-else>
                        {{ customer.role || '—' }}
                      </template>
                    </div>
                  </div>

                  <!-- Referral -->
                  <div class="col-md-6 mb-3">
                    <div class="mb-1 fw-bold">Referral/Partner</div>
                    <div class="d-flex align-items-center text-dark">
                      <Handshake class="me-2 text-muted" :size="18" />
                      <template v-if="editMode">
                        <div class="form-check form-switch">
                          <input 
                            class="form-check-input" 
                            type="checkbox" 
                            id="referralSwitch" 
                            v-model="customer.referral"
                          >
                          <label class="form-check-label" for="referralSwitch">
                            {{ customer.referral ? "Yes" : "No" }}
                          </label>
                        </div>
                      </template>
                      <template v-else>
                        {{ customer.referral ? "Yes" : "No" }}
                      </template>
                    </div>
                  </div>


                  <div class="col-md-6 mb-3">
                    <div class="mb-1 fw-bold">Website</div>
                    <div class="d-flex align-items-center text-dark">
                      <Globe class="me-2 text-muted" :size="18" />
                      <template v-if="editMode">
                        <input v-model="customer.website" type="text" class="form-control form-control-sm" :style="{
                                background: 'transparent',
                                border: 'none',
                                borderBottom: '1px solid #ccc',
                                borderRadius: '0',
                                padding: '2px 0',
                                fontSize: '0.9rem',
                                width: '100%',
                                outline: 'none'
                              }" />
                      </template>
                      <template v-else>
                        {{ customer.website }}
                      </template>
                    </div>
                  </div>


                  <div class="col-md-6 mb-3">
                    <div class="mb-1 fw-bold">Email</div>
                    <div class="d-flex align-items-center text-dark">
                      <Mail class="me-2 text-muted" :size="18" />
                      <template v-if="editMode">
                        <input v-model="customer.Email" type="email" class="form-control form-control-sm"  :style="{
                                background: 'transparent',
                                border: 'none',
                                borderBottom: '1px solid #ccc',
                                borderRadius: '0',
                                padding: '2px 0',
                                fontSize: '0.9rem',
                                width: '100%',
                                outline: 'none'
                              }"/>
                      </template>
                      <template v-else>
                        {{ customer.Email }}
                      </template>
                    </div>
                  </div>


                  <div class="col-md-6 mb-3">
                    <div class="mb-1 fw-bold">Phone</div>
                    <div class="d-flex align-items-center text-dark">
                      <NotebookTabs class="me-2 text-muted" :size="18" />
                      <template v-if="editMode">
                        <input v-model="customer.contact" type="text" class="form-control form-control-sm"  :style="{
                                background: 'transparent',
                                border: 'none',
                                borderBottom: '1px solid #ccc',
                                borderRadius: '0',
                                padding: '2px 0',
                                fontSize: '0.9rem',
                                width: '100%',
                                outline: 'none'
                              }"/>
                      </template>
                      <template v-else>
                        {{ customer.contact }}
                      </template>
                    </div>
                  </div>


                  <div class="col-12">
                    <div class="mb-1 fw-bold">Address</div>
                    <div class="d-flex align-items-center text-dark">
                      <MapPin class="me-2 text-muted" :size="18" />
                      <template v-if="editMode">
                        <input v-model="customer.address" type="text" class="form-control form-control-sm" :style="{
                                background: 'transparent',
                                border: 'none',
                                borderBottom: '1px solid #ccc',
                                borderRadius: '0',
                                padding: '2px 0',
                                fontSize: '0.9rem',
                                width: '100%',
                                outline: 'none'
                              }" />
                      </template>
                      <template v-else>
                        {{ customer.address }}
                      </template>
                    </div>
                  </div>



              </div>
            </div>
        </div>
        

      </div>
    </div>

    <div v-show="tab === 'Ideas'">
          <div class="container py-4">
              <!-- Header -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h4 class="fw-bold">Creative Ideas & Storyboards</h4>
                <div class="d-flex gap-2">
                  <button class="btn btn-sm" style="background:  linear-gradient(to right, #c2e9fb, #e0c3fc);" @click="showAddIdeaModal=true">
                     Add Manual Idea
                  </button>
                  <div>
                    <button
                      class="btn btn-sm text-white d-flex align-items-center"
                      style="background: linear-gradient(to right, #d946ef, #8b5cf6);"
                      @click="generateOneIdea()"
                      :disabled="loading"
                    >
                      <span v-if="ideaLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {{ loading ? "Generating..." : "Generate AI Idea" }}
                    </button>
                    <small class="text-muted d-block mt-1">⚡ Costs 3 credits</small>
                  </div>
                </div>
              </div>

              <!-- Search -->
              <div class="mb-4">
                <input v-model="queryIdea" type="text" class="form-control form-control-sm" placeholder="Search ideas..." />
              </div>

              <!-- Idea Cards Grid -->
              <div class="row g-3" style="padding-bottom:1px !important; max-height:56vh; overflow-y:auto; overflow-x:hidden;">
                  <div class="col-md-6" v-for="idea in filteredIdeas" :key="idea.id" style="background-color:white">
                    <div class="border rounded-4 p-4 h-100 position-relative">
                      <!-- Header Section -->
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <div class="d-flex justify-content-between align-items-center mb-1">
                              <h5 class="fw-semibold mb-0">{{ idea.Title }}</h5>
                              <Heart
                                  :size="20"
                                  :fill="idea.Fav ? 'red' : 'none'"
                                  stroke="red"
                                  class="position-absolute"
                                  style="top: 20; right: 20; cursor: pointer; transition: 0.2s"
                                  @click="toggleFav(idea)"
                              />
                            </div>
                          <p class="text-muted small mb-2">{{ idea.Description }}</p>
                          <div class="d-flex flex-wrap gap-2 mb-1">
                            <span v-for="tag in idea.Types" :key="tag" class="badge rounded-pill fw-normal" style ="background-color: #e0f2ff; color: black;">
                              {{ tag }}
                            </span>
                          </div>
                          <div class="text-muted small d-flex align-items-center">
                            <Sparkles v-if="idea.CreateBy == 'AI Generated'" class="me-2 text-muted" :size="18" /> 
                            <UserStar v-else class="me-2 text-muted" :size="18" /> 

                            
                            {{idea.CreateBy}}
                          </div>
                        </div>
                        <i class="bi bi-heart-fill text-danger"></i>
                      </div>

                      <div class="text-muted small mt-1">Created At: {{ formatDateTime(idea.createdAt) }}</div>

                      <!-- Storyboard Section -->
                      <div v-if="idea.Generated" class="rounded-3 p-3 mt-3" style="background-color:#f0f0f0;">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="fw-semibold d-flex align-items-center">
                              <Video class="me-2 text-muted" :size="18" /> Storyboard
                          </div>
                          <!-- <span class="badge bg-warning-subtle text-warning fw-medium text-capitalize">
                            {{ idea.storyboard.status }}
                          </span> -->
                        </div>
                        <!-- <div class="text-muted small mt-1">
                          Updated 2 Hours ago
                        </div> -->
                        <button class="btn btn-light w-100 mt-2"  @click="$router.push(`/Storyboard/${idea.id}`)">
                          <div class="d-flex align-items-center justify-content-center">
                            <Video class="me-2" :size="18" /> View Storyboard
                          </div>
                        </button>
                      </div>

                      <!-- Actions -->
                      <div class="d-flex justify-content-between align-items-center mt-3">
                        
                        <button
                            v-if="!idea.Generated"
                            @click="generateStoryBoard(idea.id)"
                            :disabled="storyBoardLoading"
                            class="btn btn-sm text-white flex-grow-1 me-2"
                            style="background: linear-gradient(to right, #ec4899, #d946ef); max-width: 88%;"
                          >
                            <div class="d-flex align-items-center justify-content-center">
                              <span v-if="storyBoardLoading" class="spinner-border spinner-border-sm me-2 text-white" role="status" aria-hidden="true"></span>
                              <Video v-else class="me-2 text-white" :size="18" />
                              {{ storyBoardLoading ? 'Generating…' : 'Create Storyboard' }}
                            </div>
                          </button>
                          

                        <button
                          class="btn btn-outline-danger btn-sm d-flex align-items-center justify-content-center"
                          :class="{ 'w-100': idea.Generated }" @click="deleteIdea(idea.id)"
                        >
                          <Trash2 class="text-muted" :size="18" />
                          <span v-if="idea.Generated">Delete</span>
                        </button>
                      </div>
                        <small v-if="!idea.Generated" class="text-muted d-block mt-1">🎬 Costs 6 credits</small>
                    </div>
                  </div>
              </div>
            </div>

            <!--ADD MODAL-->
            
              <div v-if="showAddIdeaModal" class="modal fade"  :class="{ show: showAddIdeaModal }" tabindex="-1"  style="display: block">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content p-3">
                    <div class="modal-header">
                      <h5 class="modal-title">Add New Idea</h5>
                      <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>

                    <div class="modal-body">
                      <div class="mb-3">
                        <label class="form-label fw-semibold">Title</label>
                        <input v-model="newIdea.title" type="text" class="form-control" />
                      </div>

                      <div class="mb-3">
                        <label class="form-label fw-semibold">Description</label>
                        <textarea v-model="newIdea.description" class="form-control" rows="3" />
                      </div>

                      <div class="mb-3">
                        <label class="form-label fw-semibold">Types (Tags)</label>

                        <div class="d-flex flex-wrap gap-2 mb-2">
                          <span
                            v-for="(tag, index) in newIdea.types"
                            :key="index"
                            class="badge bg-primary text-white d-flex align-items-center gap-1"
                          >
                            {{ tag }}
                            <X
                              class="text-white" :size="18"
                              style="cursor: pointer"
                              @click.prevent="removeTag(index)"
                            />
                          </span>
                        </div>

                        <input
                          v-model="newTag"
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="Enter tag & press Enter"
                          @keyup.enter="addTag"
                        />
                      </div>


                    </div>

                    <div class="modal-footer">
                      <button class="btn btn-secondary" @click="closeModal">Cancel</button>
                      <button class="btn btn-primary" @click="createIdea" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                        Add Idea
                      </button>
                    </div>
                  </div>
                </div>
              </div>
        </div>
        
        <div v-show="tab === 'marketTrend'">

          <div class="d-flex justify-content-end mb-3">
            <div>
            <button class="btn text-white btn-sm d-flex align-items-center gap-1"
                    style="background: linear-gradient(to right, #d946ef, #8b5cf6);"
                    @click="generateTrends"
                    :disabled="loadingTrend">

              <!-- Show spinner when loading -->
              <span v-if="loadingTrend" class="spinner-border spinner-border-sm text-white" role="status" aria-hidden="true"></span>
              <span v-if="loadingTrend"> Generating…</span>

              <!-- Show normal content when not loading -->
              <template v-else>
                <Sparkles class="text-white" :size="18" /> 
                <span>Generate Market Trends</span>
              </template>
            </button>
            <small class="text-muted d-block mt-1">⚡ Costs 1 credit</small>
            </div>
          </div>

          <div style="max-height: 70vh; overflow-x: hidden">
            <div
              v-for="trend in trends"
              :key="trend.Title"
              class="p-3 rounded-3 mb-3 border bg-white"
              
            >
              <div class="d-flex justify-content-between">
                <div>
                  <h6 class="fw-semibold mb-1">
                    <component :is="trend.icon" class="me-2 text-muted" :size="18" /> {{ trend.Title }}
                  </h6>

                  <div class="d-flex flex-wrap gap-2 mb-2">
                    <span v-for="tag in trend.Impact" :key="tag" class="badge rounded-pill fw-medium text-white"
                          :class="badgeClass(tag)">
                      {{ tag }}
                    </span>
                  </div>

                  <div class="text-muted small mb-2">{{ trend.Description }}</div>

                  <div class="small text-dark">
                    <strong>Relevance: </strong>
                    <span class="text-muted">{{ trend.Relevance }}</span>
                  </div>
                </div>

                <!-- date: no wrap + don't shrink -->
                <div class="text-end small text-muted text-nowrap flex-shrink-0 ms-3">
                  <time :datetime="trend.createdAt">{{ formatDate(trend.createdAt) }}</time>
                </div>
              </div>

            </div>
          </div>
        </div>




        <div v-show="tab === 'Notes'">

          <div class="border rounded-4 p-4">
            <h5 class="fw-bold mb-3">Internal Notes</h5>

            <textarea
              v-model="customer.notes"
              class="form-control"
              placeholder="Add your notes about this client..."
              rows="6"
              style=" border-radius: 12px; resize: vertical;"
            ></textarea>

            <button
              class="btn btn-sm mt-3 text-white fw-medium d-flex align-items-center justify-content-center gap-2"
              :disabled="isSavingNotes"
              style="background-color: #d946ef; border-radius: 12px; min-width: 120px;"
              @click="saveNotes"
            >
              <span v-if="isSavingNotes" class="spinner-border spinner-border-sm text-white" role="status" />
              <span>{{ isSavingNotes ? 'Saving...' : 'Save Notes' }}</span>
            </button>

          </div>

        </div>

        <div v-show="tab==='Sentiment'">
             <div class="p-6 space-y-6">
    <!-- Header -->
    <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div>
        <h1 class="text-3xl font-bold tracking-tight">Sentiment Analysis</h1>
        <p class="text-muted-foreground">
          Weekly market sentiment analysis with confidence scores and insights
        </p>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="grid gap-4 md:grid-cols-4">
      <div class="rounded-xl border p-4 shadow-sm">
        <p class="text-sm font-medium">Total Analyses</p>
        <div class="text-2xl font-bold">{{ filteredData.length }}</div>
        <p class="text-xs text-muted-foreground">Weekly sentiment reports</p>
      </div>
      <div class="rounded-xl border p-4 shadow-sm">
        <p class="text-sm font-medium">Avg Confidence</p>
        <div :class="['text-2xl font-bold', getConfidenceColor(averageConfidence)]">
          {{ averageConfidence === 1 ? (averageConfidence * 100 - 8) + '%' : (averageConfidence * 100) + '%' }}

        </div>
        <p class="text-xs text-muted-foreground">Analysis reliability</p>
      </div>
      <div class="rounded-xl border p-4 shadow-sm">
        <p class="text-sm font-medium">Positive</p>
        <div class="text-2xl font-bold text-green-600">{{ sentimentCounts.positive || 0 }}</div>
        <p class="text-xs text-muted-foreground">Bullish weeks</p>
      </div>
      <div class="rounded-xl border p-4 shadow-sm">
        <p class="text-sm font-medium">Negative</p>
        <div class="text-2xl font-bold text-red-600">{{ sentimentCounts.negative || 0 }}</div>
        <p class="text-xs text-muted-foreground">Bearish weeks</p>
      </div>
    </div>

    <!-- Filters -->
    <div class="flex flex-col gap-4 md:flex-row md:items-center">
      <div class="relative flex-1 max-w-sm">
        <!-- <Search class="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground h-4 w-4" /> -->
        <input
          type="text"
          v-model="searchTerm"
          placeholder="Search sentiment analysis..."
          class="pl-12 border rounded-lg w-full px-3 py-2"
          style="padding-left: 2.5rem;" 
        />
      </div>
      <div class="flex items-center gap-2">
        <Filter class="h-4 w-4 text-muted-foreground" />
        <select
          v-model="selectedSentiment"
          class="border rounded-lg px-3 py-2 w-40"
        >
          <option value="all">All Sentiment</option>
          <option value="positive">Positive</option>
          <option value="neutral">Neutral</option>
          <option value="negative">Negative</option>
        </select>
      </div>
    </div>


    <!-- Sentiment Analysis Cards -->
    <!-- wrapper with fixed height -->
    <div class="max-h-[500px] overflow-y-auto pr-2">
      <div class="grid gap-4">
        <div
          v-for="analysis in filteredData"
          :key="analysis.id"
          class="rounded-xl border p-4 hover:shadow-md transition-shadow"
        >
          <div class="flex items-center justify-between mb-3">
            <div class="flex items-center gap-3">
              <strong>{{formatDate(analysis.createdAt)}}</strong>
              <component :is="getSentimentIcon(analysis.sentiment)" class="h-5 w-5" />
              <div>
                <p class="text-lg font-semibold">{{ analysis.week }}</p>
                <p class="text-sm text-muted-foreground">{{ analysis.date }}</p>
              </div>
            </div>
            <div class="flex items-center gap-3">
              <div class="text-right">
                <p :class="['text-sm font-medium', getConfidenceColor(analysis.confidence)]">
                  {{ analysis.confidence*100 }}% Confidence
                </p>
                <p class="text-xs text-muted-foreground">Reliability Score</p>
              </div>
              <span
                class="px-2 py-1 rounded-full text-xs border"
                :class="getSentimentColor(analysis.sentiment)"
              >
                {{ capitalize(analysis.sentiment) }}
              </span>
            </div>
          </div>
          <p class="text-muted-foreground leading-relaxed">{{ analysis.summary }}</p>
        </div>
      </div>
    </div>


    <div v-if="filteredData.length === 0" class="text-center py-12">
      <p class="text-muted-foreground">
        No sentiment analysis found matching your criteria.
      </p>
    </div>
  </div>
        </div>

  </Layout>

</template>

<script>
import Layout from '@/components/Layout.vue';
import { useToast } from 'vue-toastification'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import router from "@/router";
import axios from "axios";
import { Building2,UserRound,NotebookTabs,Globe,Mail,MapPin,Sparkles,
        UserStar,Video, Trash2, Heart, X,Network,Handshake,
         Filter, TrendingUp, TrendingDown, Minus} 
        from 'lucide-vue-next';

export default {
  name: 'CrmPage',
  components: { Layout,Building2,UserRound,NotebookTabs,Globe,Mail,MapPin,
                Sparkles,UserStar,Video,Trash2, Heart, X,Network,Handshake,
                 Filter, TrendingUp, TrendingDown, Minus },
  data() {
    return {
      tab: 'Overview',
      editMode: false,
      isSaving: false,
      isSavingNotes: false,
      showAddIdeaModal:false,
      loading: false,
      ideaLoading:false,
      storyBoardLoading:false, 
      loadingTrend:false, 
      newTag: '',
      newIdea: {
        title: '',
        description: '',
        types: []
      },
      queryIdea:"",
      clientID:"",
      userID:"",
      token:"",
      // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      customer:{},
      ideas: [],
      trends: [],          // marketing trends list
      searchTerm: "",
      selectedSentiment: "all",
      sentiments:[],
      mockSentimentData: [
        {
          id: 1,
          week: "Week of Dec 25, 2024",
          date: "2024-12-25",
          sentiment: "positive",
          summary:
            "Market shows strong bullish sentiment with increased investor confidence following positive earnings reports and favorable economic indicators.",
          confidence: 85,
        },
        {
          id: 2,
          week: "Week of Dec 18, 2024",
          date: "2024-12-18",
          sentiment: "neutral",
          summary:
            "Mixed market signals with equal amounts of positive and negative sentiment. Investors remain cautious ahead of year-end decisions.",
          confidence: 72,
        },
        {
          id: 3,
          week: "Week of Dec 11, 2024",
          date: "2024-12-11",
          sentiment: "positive",
          summary:
            "Strong positive sentiment driven by tech sector growth and improved consumer spending data. Market optimism continues to rise.",
          confidence: 91,
        },
        {
          id: 4,
          week: "Week of Dec 4, 2024",
          date: "2024-12-04",
          sentiment: "negative",
          summary:
            "Bearish sentiment dominates as inflation concerns and geopolitical tensions weigh on market performance. Risk-off behavior observed.",
          confidence: 78,
        },
        {
          id: 5,
          week: "Week of Nov 27, 2024",
          date: "2024-11-27",
          sentiment: "neutral",
          summary:
            "Holiday trading week shows muted sentiment with low volume. Market participants taking wait-and-see approach.",
          confidence: 65,
        },
        {
          id: 6,
          week: "Week of Nov 20, 2024",
          date: "2024-11-20",
          sentiment: "positive",
          summary:
            "Thanksgiving week brings positive sentiment as retail sales data exceeds expectations and consumer confidence improves.",
          confidence: 82,
        },
      ],
    };
  },
  setup() {
    const toast = useToast()

    return {
      toast
    }
  },
  methods: {
      async fetchSentiment() {
        try {
          const headers = await this.getAuthHeader()
          const res = await axios.get(`${this.apiURL}/api/sentiment/${this.clientID}`, {headers});
          this.sentiments = res.data; // the array returned from Flask
        } catch (err) {
          this.toast.error("Failed to load sentiment data");
        } 
      },

      async getMarketingTrends() {
        try {
          this.trendsLoading = true
          const headers = await this.getAuthHeader()

          const res = await axios.get(`${this.apiURL}/getMarketingTrends`, {
            params: { customerID: this.clientID },
            headers
          })

          if (res.data.code === 200) {
            this.trends = res.data.data   // contains createdAtFormatted, CreateByName if your API adds them
          } else {
            this.toast.error(res.data.message || 'Failed to load marketing trends')
          }
        } catch (err) {
          console.error('getMarketingTrends error:', err)
          this.toast.error('Something went wrong loading trends')
        } finally {
          this.trendsLoading = false
        }
      },
     async generateTrends() {
      if (this.loadingTrend) return;
      this.loadingTrend = true;
      this.errorTrend = null;
        const headers = await this.getAuthHeader();

      try {
        const res = await axios.post(
          this.apiURL + "/marketTrend",
          {
            userID: this.userID,
            companyID: this.clientID
          },
          {
            headers
          }
        );

        console.log("MarketTrend response:", res);
        if (!res.data.creditSufficient){
          this.toast.error("Insufficient Credit")
        }
        // 👉 trigger sidebar refresh
        this.refreshCredits("refreshCredits");

        // 👉 reload trend list after generation (optional)
        await this.getMarketingTrends();

      } catch (err) {
        // console.error("Generate trends failed:", err);
        // this.errorTrend = err.message || "Failed to generate trends";
        this.toast.error("Failed to generate trends")
      } finally {
        this.loadingTrend = false;
      }
    },
    refreshCredits() {
      this.$refs.sidebar.fetchCredits(); // call sidebar method
    },
    async generateStoryBoard(ideaID) {
      this.storyBoardLoading = true;

      try {
        const headers = await this.getAuthHeader();
        const res = await axios.post(this.apiURL+"/generateStoryBoard", {
          ideaID: ideaID,
          userID: this.userID,
        }, {
        headers
      });
        if (!res.data.creditSufficient){
          this.toast.error("Insufficient Credit")
        }else{
          this.toast.success("Generated Successfully")
          this.getIdeas();
        }
      } catch (err) {
        console.error(err);
        this.toast.error("Error Occured, If Error Persist Please Call Admin")
      } finally {
        this.storyBoardLoading = false;
        this.refreshCredits()
      }
    },
    async generateOneIdea() {
      this.ideaLoading = true;
      try {
        const headers = await this.getAuthHeader();

        const res = await axios.post(this.apiURL+"/generateOneIdea", {
          customerId: this.clientID,
          userID: this.userID,
        }, {
        headers
      });
        if (!res.data.creditSufficient){
          this.toast.error("Insufficient Credit")
        }else{
          this.toast.success("Generated Successfully")
          this.getIdeas();
        }
      } catch (err) {
        console.error(err);
        this.toast.error("Error Occured, If Error Persist Please Call Admin")

      } finally {
        this.ideaLoading = false;
        this.refreshCredits()

      }
    },
    badgeClass() {
      // if (tag.toLowerCase() === 'trend') return 'bg-primary text-primary';
      // if (tag.toLowerCase() === 'global') return 'bg-info text-info';
      // if (tag.toLowerCase() === 'high impact') return 'bg-danger text-danger';
      return 'bg-primary text-primary';
    },
    async deleteIdea(ideaId) {
      try {
        console.log(ideaId)
        const headers = await this.getAuthHeader(); // 🔐 assumes you already have this method
        const res = await axios.delete(`${this.apiURL}/deleteIdea/${ideaId}`, { headers });

        if (res.data.code === 200) {
          this.toast.success('Idea deleted successfully');
          this.getIdeas(); // refresh list
        } else {
          this.toast.error(res.data.message || 'Failed to delete idea');
        }
      } catch (err) {
        console.error(err);
        this.toast.error('Something went wrong while deleting');
      }
    },
    closeModal() {
      this.showAddIdeaModal = false;
      this.resetModal();
    },
    resetModal() {
      this.newIdea = { title: '', description: '', types: [] };
      this.newTag = '';
      this.loading = false;
    },
    addTag() {
      const tag = this.newTag.trim();
      if (tag && !this.newIdea.types.includes(tag)) {
        this.newIdea.types.push(tag);
      }
      this.newTag = '';
    },
    removeTag(index) {
      this.newIdea.types.splice(index, 1);
    },
    async toggleFav(idea) {
      try {
        const headers = await this.getAuthHeader();
        const payload = { Fav: !idea.fav };

        const res = await axios.put(
          `${this.apiURL}/updateIdea/${idea.id}`,
          payload,
          { headers }
        );

        if (res.data.code === 200) {
          idea.fav = !idea.fav;
          this.toast.success(`Marked as ${idea.fav ? 'favourite' : 'not favourite'}`);
        } else {
          this.toast.error(res.data.message || "Failed to update favourite");
        }
      } catch (err) {
        console.error(err);
        this.toast.error("Something went wrong");
      }
    },
    async createIdea() {
    try {
      const headers = await this.getAuthHeader();
      const res = await axios.post(this.apiURL + '/createIdea', {
        CustomerID: this.clientID,
        Title:this.newIdea.title,
        Description: this.newIdea.description,
        CreateBy: this.userID,
        Types: this.newIdea.types,
        Generated: false,
      }, {
        headers
      });

      if (res.data.code === 200) {
        console.log('Idea created:', res.data.id);
        this.toast.success('Idea Created Successfully')
        this.closeModal()
        this.getIdeas(); // refresh after create
      } else {
        console.error('Error:', res.data.message);
      }
    } catch (err) {
      console.error('API error:', err);
    }
  },

  async getIdeas() {
    try {
      const headers = await this.getAuthHeader();
      const res = await axios.get(this.apiURL + '/getIdeas', {
        params: {
          customerID: this.clientID
        },
        headers
      });

      if (res.data.code === 200) {
        this.ideas = res.data.data;
      } else {
        console.error('Error:', res.data.message);
      }
    } catch (err) {
      console.error('API error:', err);
    }
  },
    async getAuthHeader() {
      const user = getAuth().currentUser;
      if (!user) throw new Error('Not logged in');

      const token = await user.getIdToken(); // 🔐 always fresh
      return {
        Authorization: token
      };
    },
    handleButtonClick() {
      if (this.isSaving) return

      if (this.editMode) {
        this.saveChanges()
      } else {
        this.editMode = true
      }
    },
    async saveChanges() {
      try {
        this.isSaving = true
        const headers = await this.getAuthHeader();
        const payload = {
          contact: this.customer.contact,
          Email: this.customer.Email,
          website: this.customer.website,
          address: this.customer.address,
          contactPerson: this.customer.contactPerson,
          role:this.customer.role,
          referral:this.customer.referral
        };

        const res = await axios.put(
        `${this.apiURL}/updateCompany/${this.clientID}`,
        payload,
        { headers } // ✅ correct position + syntax
      );

        if (res.data.code === 200) {
          this.toast.success("Updated successfully");
          this.loadCustomers();

        } else {
          this.toast.error(res.data.message || "Update failed");
        }
      } catch (err) {
        console.error(err);
        this.$toast.error("Something went wrong");
      } finally {
        this.isSaving = false
        this.editMode = false
      }
    },
    async saveNotes() {
      try {
        this.isSavingNotes = true;
        const headers = await this.getAuthHeader();
        const payload = {
          notes: this.customer.notes, // 👈 only sending notes
        };

        const res = await axios.put(
          `${this.apiURL}/updateCompany/${this.clientID}`,
          payload,
          { headers }
        );

        if (res.data.code === 200) {
          this.toast.success("Notes updated successfully");
          this.loadCustomers();
        } else {
          this.toast.error(res.data.message || "Update failed");
        }
      } catch (err) {
        console.error(err);
        this.toast.error("Something went wrong");
      } finally {
        this.isSavingNotes = false;
      }
    },
    async checkAuthState() {
            const auth = getAuth();
            return new Promise((resolve, reject) => {
            onAuthStateChanged(auth, async (user) => {
                if (user) {
                try {
                    const idToken = await user.getIdToken();
                    this.token = idToken;
                    resolve(); // 🔥 Only resolve when token is ready
                } catch (error) {
                    reject(error);
                }
                } else {
                router.push("/");
                reject(new Error("No user logged in"));
                }
            });
            });
    },
    async loadCustomers() {
       const headers = await this.getAuthHeader();
      try {
        const res = await axios.get(`${this.apiURL}/getCompanyById/`+this.clientID, {
          headers
        });

        this.customer = res.data.data;
        console.log("✅ Customers loaded:", this.customerList);
      } catch (err) {
        this.toast.error("Error Fetching")
        // console.error("❌ Failed to load customers:", err.response?.data || err.message);
      }
    },
      
    async loadCustomerLogs() {
      try {
        const res = await axios.get(`${this.apiURL}/api/logs`, {
          params: { userID: this.userID },
          headers: { Authorization: this.token }
        });
        this.customerLogs = res.data || [];
        console.log("✅ Logs loaded:", this.customerLogs);
      } catch (err) {
        this.toast.error("Error Fetching")

        // console.error("❌ Failed to load logs:", err.response?.data || err.message);
        this.customerLogs = [];
      }
    },
    
    formatDateTime(dateTimeString) {
      if (!dateTimeString) return '-';
      const date = new Date(dateTimeString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    formatDate(dateInput) {
      if (!dateInput) return '-';

      let date;
      if (dateInput instanceof Date) {
        date = dateInput;
      } else if (typeof dateInput === 'object' && dateInput.seconds) {
        // Firestore Timestamp support
        date = new Date(dateInput.seconds * 1000);
      } else {
        date = new Date(String(dateInput));
      }

      if (isNaN(date)) return '-';

      // Date only, no time
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'Asia/Singapore',
      });
    },

    formatToInputDate(dateStr) {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`; // MUST be yyyy-MM-dd
      },
    getSentimentIcon(sentiment) {
      switch (sentiment) {
        case "positive":
          return "TrendingUp";
        case "negative":
          return "TrendingDown";
        default:
          return "Minus";
      }
    },
    getSentimentColor(sentiment) {
      switch (sentiment) {
        case "positive":
          return "bg-green-100 text-green-800 border-green-200";
        case "negative":
          return "bg-red-100 text-red-800 border-red-200";
        default:
          return "bg-yellow-100 text-yellow-800 border-yellow-200";
      }
    },
    getConfidenceColor(conf) {
      if (conf >= 80) return "text-green-600";
      if (conf >= 60) return "text-yellow-600";
      return "text-red-600";
    },
    capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    

  },
  computed: {
     
    filteredIdeas() {
      const q = this.queryIdea.trim().toLowerCase();
      if (!q) return this.ideas;
      return this.ideas.filter(idea => idea.Title.toLowerCase().includes(q));
    },
    filteredData() {
      return this.sentiments.filter((item) => {
        const matchesSearch =
          item.summary.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          item.week.toLowerCase().includes(this.searchTerm.toLowerCase());
        const matchesSentiment =
          this.selectedSentiment === "all" || item.sentiment === this.selectedSentiment;
        return matchesSearch && matchesSentiment;
      });
    },
    averageConfidence() {
      if (!this.filteredData.length) return 0;
      const sum = this.filteredData.reduce((s, i) => s + i.confidence, 0);
      return Math.round(sum / this.filteredData.length);
    },
    sentimentCounts() {
      return this.filteredData.reduce((acc, item) => {
        acc[item.sentiment] = (acc[item.sentiment] || 0) + 1;
        return acc;
      }, {});
    },
  },
  async mounted(){
      this.userID = this.$store.getters.getUserId;
      this.clientID = this.$route.params.id
      await this.checkAuthState();
      this.loadCustomers();
      this.getIdeas();
      this.getMarketingTrends();
      this.fetchSentiment();

      // this.loadCustomerLogs();
      // this.fetchMeetingsByDate();
  },
};
</script>

<style scoped>
.custom-h3 {
  all: unset;
  display: block;
  font-weight: 700; /* same as fw-bold */
  font-size: 1.25rem; /* same as h3 */
  margin-bottom: 0.5rem; /* same as mb-2 */
}

.modal-backdrop-fix {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-fix {
  z-index: 1050;
}
.btn-sm {
  height: 40px; /* or whatever looks good */
}
</style>
